<template>
  <div class="vehicle" :class="'-view-' + viewMode">
    <!-- <VehicleCarousel :id="vehicle.id" :images="vehicle.images" :title="vehicleTitle" /> -->

    <div class="vehicle__image" :class="vehicle.images.length > 0 ? '' : 'vehicle__image--empty'">
      <router-link :to="'voertuig/' + vehicle.id + '/' + vehicleSlug" tag="button">
        <img v-if="vehicle.images.length > 0" :to="'voertuig/'" alt="" :src="vehicle.images[0]" />
      </router-link>
    </div>
    <!-- .vehicle__image -->

    <div class="vehicle__content">
      <h1 class="vehicle__title">
        <span>{{ vehicle.properties.brand }}</span> {{ vehicle.properties.model }}
      </h1>
      <p class="vehicle__subTitle">{{ vehicleSubTitle | carSelexy | cleanTitle(85) }}</p>
      <div class="vehicle__priceWrapper">
        <div>
          <span v-if="vehicle.properties.price" class="vehicle__price">
            {{ vehicle.properties.price | toEUR }}
            <span v-if="vehicle.properties.priceInclTax === false && vehicle.properties.btwMarge === 'BTW'" class="vehicle__price__tax">{{
              $t('vehicle.exclTax')
            }}</span>
          </span>
          <div class="vehicle__monthlyPrice" v-if="vehicle.properties.priceFinanceAmount">
            {{ $t('vehicle.finance.from') }} {{ vehicle.properties.priceFinanceAmount | round | toEUR }}
            {{ $t('vehicle.finance.perMonth') }}
          </div>

          <div class="vehicle__monthlyPrice" v-if="vehicle.properties.pricePrivateLeaseAmount">
            {{ $t('vehicle.finance.privateLeaseFrom') }} {{ vehicle.properties.pricePrivateLeaseAmount | round | toEUR }}
            {{ $t('vehicle.finance.perMonth') }}
          </div>
        </div>
        <div v-if="isCarSelexy">
          <img class="vehicle__inlineCarSelexyLogo" :src="WPSettings.ASSETS_DIR + '/logo-carselexy.svg'" alt="CarSelexy" />
        </div>
      </div>
      <!-- .vehicle__priceWrapper -->

      <div class="vehicle__props">
        <ul class="vehicle__propsList">
          <li class="vehicle__propsList__item">{{ vehicle.properties.year }}</li>
          <li class="vehicle__propsList__item">
            {{ vehicle.properties.mileage | thousandSeparated }} {{ vehicle.properties.mileageUnit }}
            <img
              v-if="vehicle.properties.warranty.nap"
              class="vehicle__inlineNapLogo"
              :src="WPSettings.ASSETS_DIR + '/logo-nap.jpg'"
              alt="NAP-Check"
            />
          </li>
          <li class="vehicle__propsList__item">
            {{ vehicle.properties.enginePowerKW }} {{ $t('vehicle.energyPowerUnit') }} ({{ vehicle.properties.enginePowerPK }}
            {{ $t('vehicle.horsePowerUnit') }})
          </li>
        </ul>
        <ul class="vehicle__propsList">
          <li class="vehicle__propsList__item">{{ vehicle.properties.fuelType }}</li>
          <li class="vehicle__propsList__item">{{ vehicle.properties.transmission }}</li>
          <li class="vehicle__propsList__item">{{ vehicle.properties.body }}</li>
        </ul>
      </div>

      <div class="vehicle__actions">
        <router-link
          class="vehicle__button button button--primary button--arrow"
          :to="'voertuig/' + vehicle.id + '/' + vehicleSlug"
          >{{ viewMode === 'list' ? $t('loop.viewCar') : $t('loop.view') }}</router-link
        >

        <button
          v-if="showCompare"
          @click="addVehicle(vehicle)"
          class="vehicle__button button button--secondary"
          :class="isAddedToCompare(vehicle) ? 'button--check' : 'button--compare'"
        >
          {{ $t('loop.compare') }}
        </button>
      </div>
      <!-- .vehicle__actions -->
    </div>
    <!-- .vehicle__content -->
  </div>
  <!-- .vehicle -->
</template>

<script>
import { WPSettings } from '@/WPSettings'
import VehicleCarousel from '@/components/VehicleCarousel.vue'

export default {
  name: 'vehicle',
  components: {
    VehicleCarousel,
  },
  props: ['vehicle'],
  data() {
    return {
      WPSettings: WPSettings,
    }
  },
  computed: {
    viewMode: function () {
      return this.$store.state.vehicles.viewMode
    },
    vehicleTitle: function () {
      const brand = this.vehicle.properties.brand ?? ''
      const model = this.vehicle.properties.model ?? ''
      const type = this.vehicle.properties.type ?? ''
      return (brand + ' ' + model + ' ' + type).replace('  ', ' ')
    },
    vehicleSubTitle: function () {
      const type = this.vehicle.properties.type ?? ''
      const addition = this.vehicle.properties.addition ?? ''
      return (type + ' ' + addition).replace('  ', ' ')
    },
    isCarSelexy: function () {
      return this.vehicle.properties.type?.includes('CarSelexy') || this.vehicle.properties.description?.includes('CarSelexy')
    },
    vehicleSlug: function () {
      return this.$options.filters.slugify(this.vehicleTitle)
    },
    showCompare: function () {
      return this.$store.state.settings.general.showCompare
    },
  },
  methods: {
    addVehicle(vehicle) {
      this.$store.commit('compare/addVehicle', vehicle)
      this.$router.push({ path: '/vergelijken' })
    },
    isAddedToCompare(vehicle) {
      const compareVehicles = this.$store.getters['compare/vehicles']
      return compareVehicles.includes(vehicle.id)
    },
  },
}
</script>
